export default "__VITE_ASSET__Cy3HQZ7q__"